




























import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';

const ALLOWED_TYPES = ['generic', 'user', 'page', 'event', 'market-item', 'post'];

export default {
    name: 'CoNotFound',
    components: {
        CoButton,
        CoHeadline,
        CoText,
    },
    props: {
        type: {
            type: String,
            default: 'generic',
            validator(value) {
                if (!value) return true;
                const normalized = value
                    .toString()
                    .toLowerCase()
                    .replace(/[\s_]+/g, '-');
                return ALLOWED_TYPES.includes(normalized);
            },
        },
    },
    computed: {
        // Reuse the generic 404 copy when events are globally disabled for this space.
        resolvedType(): string {
            if (this.type === 'event' && this.$store?.state?.space?.EventsOff) {
                return 'generic';
            }

            return this.type;
        },
        resolvedTitle(): string {
            switch (this.resolvedType) {
                case 'user':
                    return this.$t('notFound.titles.user');
                case 'page':
                    return this.$t('notFound.titles.page');
                case 'event':
                    return this.$t('notFound.titles.event');
                case 'market-item':
                    return this.$t('notFound.titles.marketItem');
                case 'post':
                    return this.$t('notFound.titles.post');
                case 'generic':
                    return this.$t('notFound.titles.generic');
                default:
            }
            return this.$t('notFound.titles.generic');
        },
        resolvedMessage(): string {
            switch (this.resolvedType) {
                case 'user':
                    return this.$t('notFound.messages.user');
                case 'page':
                    return this.$t('notFound.messages.page');
                case 'event':
                    return this.$t('notFound.messages.event');
                case 'market-item':
                    return this.$t('notFound.messages.marketItem');
                case 'post':
                    return this.$t('notFound.messages.post');
                case 'generic':
                    return this.$t('notFound.messages.generic');
                default:
            }
            return this.$t('notFound.messages.generic');
        },
        primaryLabel(): string {
            switch (this.resolvedType) {
                case 'user':
                    return this.$t('notFound.actions.primary.user');
                case 'page':
                    return this.$t('notFound.actions.primary.generic');
                case 'event':
                    return this.$t('notFound.actions.primary.event');
                case 'marketItem':
                    return this.$t('notFound.actions.primary.marketItem');
                case 'post':
                    return this.$t('notFound.actions.primary.generic');
                case 'generic':
                default:
                    return this.$t('notFound.actions.primary.generic');
            }
        },
    },
    methods: {
        handleBack() {
            if (this.$router) {
                if (typeof window !== 'undefined' && window.history.length > 2) {
                    //  we need to go back to 2 pages to avoid landing on the same not found page again
                    this.$router.go(-2);
                    return;
                }
                this.$router.push('/');
            }
        },
        handlePrimary() {
            switch (this.resolvedType) {
                case 'user':
                    this.$router.push('/community');
                    break;
                case 'page':
                    this.$router.push('/');
                    break;
                case 'event':
                    this.$router.push('/events');
                    break;
                case 'market-item':
                    this.$router.push('/market');
                    break;
                case 'post':
                    this.$router.push('/');
                    break;
                case 'generic':
                default:
                    this.$router.push('/');
            }
        },
    },
};
